import './LoginBar.css';
import { Link, useHistory } from 'react-router-dom';
import { getAuth, signOut } from "firebase/auth";
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { BsFillPersonFill } from 'react-icons/bs';
import { ImExit } from 'react-icons/im';
import NavigationBar from '../NavigationBar/NavigationBar';
import { useSelectedSquareFootage, useSelectedTitle, useSelectedBussinesMedia, useSelectedBussinesAdditions, useSelectedLandMedia, useSelectedRoadType, useSelectedMeasuresWidth, useSelectedMeasuresHeight, useSelectedFloorsNumberInBuilding, useSelectedBasementInfo, useSelectedBalconyNumber, useSelectedParkingSpot, useSelectedHeatingType, useSelectedFloorNumber, useSelectedRoomsNumber, useSelectedElevatorStatus, useSelectedBuildStatus, useSelectedBuildYear, useSelectedDescription, useRefreshUserInfo, useSelectedCity, useAwaitOffer, useLoggedUser, useSecondFilter, useCountryFilter, useMainFilter, useCityFilter, useShowPopUpModal, useModalVersion, useModalInfo, useSelectedMainCategory, useSelectedSpeciality
  , useSelectedMarket, useSelectedPrice, useSelectedStreet, useSelectedBuilding, useSelectedLocal, useSelectedAdressLat, useSelectedAdressLng, useSelectedImages
 } from '../../../data/GlobalStates';
import { useAtom } from 'jotai';

const TopBar = () => {

   const authedUser = getAuth();
   const history = useHistory();

   //stany globalne:
   const [ LoggedUser, setLoggedUser ] = useAtom(useLoggedUser);
   const [ SecondFilter, setSecondFilter ] = useAtom(useSecondFilter);
   const [ CountryFilter, setCountryFilter] = useAtom(useCountryFilter);
   const [ MainFilter, setMainFilter ] = useAtom(useMainFilter);
   const [ CityFilter, setCityFilter ] = useAtom(useCityFilter);
   const [ ShowPopUpModal, setShowPopUpModal ] = useAtom(useShowPopUpModal);
   const [ ModalVersion, setModalVersion ] = useAtom(useModalVersion);
   const [ ModalInfo, setModalInfo ] = useAtom(useModalInfo);
   const [ AwaitOffer, setAwaitOffer ] = useAtom(useAwaitOffer);
   const [ SelectedSpeciality, setSelectedSpeciality] = useAtom(useSelectedSpeciality);
   const [ SelectedMarket, setSelectedMarket ] = useAtom(useSelectedMarket);
   const [ SelectedPrice, setSelectedPrice ] = useAtom(useSelectedPrice);
   const [ SelectedCity, setSelectedCity ] = useAtom(useSelectedCity);
   const [ SelectedStreet, setSelectedStreet ] = useAtom(useSelectedStreet);
   const [ SelectedBuilding, setSelectedBuilding ] = useAtom(useSelectedBuilding);
   const [ SelectedLocal, setSelectedLocal ] = useAtom(useSelectedLocal);
   const [ SelectedAdressLat, setSelectedAdressLat ] = useAtom(useSelectedAdressLat);
   const [ SelectedAdressLng, setSelectedAdressLng ] = useAtom(useSelectedAdressLng);
   const [ SelectedMainCategory, setSelectedMainCategory ] = useAtom(useSelectedMainCategory);
   const [ SelectedImages, setSelectedImages ] = useAtom(useSelectedImages);
   const [ RefreshUserInfo, setRefreshUserInfo ] = useAtom(useRefreshUserInfo);
   const [ SelectedDescription, setSelectedDescription ] = useAtom(useSelectedDescription);
   const [ SelectedBuildYear, setSelectedBuildYear ] = useAtom(useSelectedBuildYear);
   const [ SelectedBuildStatus, setSelectedBuildStatus ] = useAtom(useSelectedBuildStatus);
   const [ SelectedElevatorStatus, setSelectedElevatorStatus ] = useAtom(useSelectedElevatorStatus);
   const [ SelectedRoomsNumber, setSelectedRoomsNumber ] = useAtom(useSelectedRoomsNumber);
   const [ SelectedFloorNumber, setSelectedFloorNumber ] = useAtom(useSelectedFloorNumber);
   const [ SelectedHeatingType, setSelectedHeatingType ] = useAtom(useSelectedHeatingType);
   const [ SelectedParkingSpot, setSelectedParkingSpot ] = useAtom(useSelectedParkingSpot);
   const [ SelectedBalconyNumber, setSelectedBalconyNumber ] = useAtom(useSelectedBalconyNumber);
   const [ SelectedBasementInfo, setSelectedBasementInfo ] = useAtom(useSelectedBasementInfo);
   const [ SelectedFloorsNumberInBuilding, setSelectedFloorsNumberInBuilding ] = useAtom(useSelectedFloorsNumberInBuilding);
   const [ SelectedMeasuresHeight, setSelectedMeasuresHeight ] = useAtom(useSelectedMeasuresHeight);
   const [ SelectedMeasuresWidth, setSelectedMeasuresWidth ] = useAtom(useSelectedMeasuresWidth);
   const [ SelectedRoadType, setSelectedRoadType ] = useAtom(useSelectedRoadType);
   const [ SelectedLandMedia, setSelectedLandMedia ] = useAtom(useSelectedLandMedia);
   const [ SelectedBussinesAdditions, setSelectedBussinesAdditions ] = useAtom(useSelectedBussinesAdditions);
   const [ SelectedBussinesMedia, setSelectedBussinesMedia ] = useAtom(useSelectedBussinesMedia);
   const [ SelectedTitle, setSelectedTitle ] = useAtom(useSelectedTitle);
   const [ SelectedSquareFootage, setSelectedSquareFootage ] = useAtom(useSelectedSquareFootage);

   

   const logOut = () => {
     signOut(authedUser)
       .then(() => {
          setLoggedUser('')
          history.push('/')
          setShowPopUpModal(true)
          setModalVersion(12)
          setModalInfo({title: 'Wylogowano poprawnie'})
       })
   };

   const cleanFilters = () => {
    setCountryFilter('')
    setCityFilter('')
    setMainFilter('')
    setSecondFilter('')
   };

   const cleanEditFields = () => {
    if (!LoggedUser) {
      setRefreshUserInfo(RefreshUserInfo + 1)
    }
    setAwaitOffer('')
    setSelectedMainCategory('Wybierz')//
    setSelectedSpeciality('Wybierz')//
    setSelectedMarket('Wybierz')//
    setSelectedCity('')//
    setSelectedStreet('')//
    setSelectedBuilding('')//
    setSelectedLocal('')//
    setSelectedAdressLat('')//
    setSelectedAdressLng('')//
    setSelectedPrice('')//
    setSelectedImages([])// zawsze początkowy jako tablica 
    setSelectedDescription('')
    setSelectedBuildYear('')
    setSelectedBuildStatus('')
    setSelectedElevatorStatus('')
    setSelectedRoomsNumber('')
    setSelectedFloorNumber('')
    setSelectedHeatingType('')
    setSelectedParkingSpot('')
    setSelectedBalconyNumber('')
    setSelectedBasementInfo('')
    setSelectedFloorsNumberInBuilding('')
    setSelectedMeasuresHeight('')
    setSelectedMeasuresWidth('')
    setSelectedRoadType('')
    setSelectedLandMedia([])
    setSelectedBussinesAdditions([])
    setSelectedBussinesMedia([])
    setSelectedTitle('')
    setSelectedSquareFootage('')
   };

 
    return ( 
         <div id='TopBarMainDiv'>
            <div className='LogoAndButtons'>
              <div className='LogoAndSubLogo' onClick={() => cleanFilters()}>
                 <Link to='/' className='MainLogoText'>
                    Polska Akademia Tyczki
                 </Link>
              </div>

              <NavigationBar/>

         <div className='MainButtonsContainer'>
           {authedUser.currentUser && LoggedUser.Verified && (
             <Link to='/DodajNews' className='MainButtons'>
               <span className='btn-text'>Dodaj News</span>
               <AiOutlinePlusCircle className='btn-icon' />
             </Link>
            )}

            {authedUser.currentUser && (
             <Link to='/userPanel' className='MainButtons'>
               <span className='btn-text'>Konto</span>
               <BsFillPersonFill className='btn-icon' />
             </Link>
            )}

           {!authedUser.currentUser && !LoggedUser ? (
             <Link to='/login' className='MainButtons'>
               <span className='btn-text'>Logowanie</span>
               <BsFillPersonFill className='btn-icon' />
             </Link>
  ) : (

         <div className='MainButtons' onClick={logOut}>
           <span className='btn-text'>Wyloguj</span>
           <ImExit className='btn-icon' />
         </div>
          )}
         </div>

          </div>
         </div>
  )
}

export default TopBar;
